<template>
    <cp-select
        :config="configUsers"
        item-value="id"
        item-text="name"
        clearable
        v-on="$listeners"
        v-bind="attrs"
        :customSelection="true"
    >
        <template v-slot:selection="{ item }">

        </template>
    </cp-select>
</template>

<script>

export default {
    props: {
        configUsers: {
            type: Object,
            required: false,
            default: () => { return {route: 'v2.users.select'} },
        },
    },

    computed: {
        attrs() {
            const { label, name, ...attrs } = this.$attrs;

            return { ...{
                label: label || 'Selecione um usuário',
                name: name || "select-user"
            }, ...attrs };
        },
    },
}
</script>